var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "tabsWrap", class: _vm.classes }, [
    _c("div", { class: [_vm.prefixCls + "-bar"] }, [
      _vm.showSlot
        ? _c(
            "div",
            { class: [_vm.prefixCls + "-nav-right"] },
            [_vm._t("extra")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "navContainer",
          class: [_vm.prefixCls + "-nav-container"],
          attrs: { tabindex: "0" },
          on: {
            keydown: [
              _vm.handleTabKeyNavigation,
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.handleTabKeyboardSelect(false)
              }
            ]
          }
        },
        [
          _c(
            "div",
            {
              ref: "navWrap",
              class: [
                _vm.prefixCls + "-nav-wrap",
                _vm.scrollable ? _vm.prefixCls + "-nav-scrollable" : ""
              ]
            },
            [
              _c(
                "span",
                {
                  class: [
                    _vm.prefixCls + "-nav-prev",
                    _vm.scrollable ? "" : _vm.prefixCls + "-nav-scroll-disabled"
                  ],
                  on: { click: _vm.scrollPrev }
                },
                [_c("Icon", { attrs: { type: "ios-arrow-back" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    _vm.prefixCls + "-nav-next",
                    _vm.scrollable ? "" : _vm.prefixCls + "-nav-scroll-disabled"
                  ],
                  on: { click: _vm.scrollNext }
                },
                [_c("Icon", { attrs: { type: "ios-arrow-forward" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "navScroll",
                  class: [_vm.prefixCls + "-nav-scroll"],
                  on: {
                    DOMMouseScroll: _vm.handleScroll,
                    mousewheel: _vm.handleScroll
                  }
                },
                [
                  _c(
                    "div",
                    {
                      ref: "nav",
                      class: [_vm.prefixCls + "-nav"],
                      style: _vm.navStyle
                    },
                    [
                      _c("div", { class: _vm.barClasses, style: _vm.barStyle }),
                      _vm._v(" "),
                      _vm._l(_vm.navList, function(item, index) {
                        return _c(
                          "div",
                          {
                            class: _vm.tabCls(item),
                            attrs: { draggable: _vm.draggable },
                            on: {
                              click: function($event) {
                                return _vm.handleChange(index)
                              },
                              dblclick: function($event) {
                                return _vm.handleDblclick(index)
                              },
                              contextmenu: function($event) {
                                $event.stopPropagation()
                                return _vm.handleContextmenu(index, $event)
                              },
                              selectstart: function($event) {
                                $event.stopPropagation()
                                return _vm.handlePreventSelect(index, $event)
                              },
                              dragstart: function($event) {
                                return _vm.handleDrag(index, $event)
                              },
                              drop: function($event) {
                                return _vm.handleDrop(index, $event)
                              },
                              dragover: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            item.icon !== ""
                              ? _c("Icon", { attrs: { type: item.icon } })
                              : _vm._e(),
                            _vm._v(" "),
                            item.labelType === "function"
                              ? _c("Render", { attrs: { render: item.label } })
                              : [_vm._v(_vm._s(item.label))],
                            _vm._v(" "),
                            _vm.showClose(item)
                              ? _c("Icon", {
                                  class: [_vm.prefixCls + "-close"],
                                  attrs: {
                                    type: _vm.arrowType,
                                    custom: _vm.customArrowType,
                                    size: _vm.arrowSize
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleRemove(index)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "panes", class: _vm.contentClasses, style: _vm.contentStyle },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ivu-tabs-context-menu", style: _vm.contextMenuStyles },
      [
        _c(
          "Dropdown",
          {
            attrs: {
              trigger: "custom",
              visible: _vm.contextMenuVisible,
              transfer: ""
            },
            on: { "on-clickoutside": _vm.handleClickContextMenuOutside }
          },
          [
            _c(
              "DropdownMenu",
              { attrs: { slot: "list" }, slot: "list" },
              [_vm._t("contextMenu")],
              2
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-003f8fc5", { render: render, staticRenderFns: staticRenderFns })
  }
}